import React from 'react';

const Footer = ({ setActiveSection }) => {
  return (
    <footer className="footer">
      <div className="container">
        <p>📱 Phone Paradise - Tu tienda de confianza en Palafolls</p>
        
        {/* Enlaces legales */}
        <div style={{ marginTop: '1rem' }}>
          <button 
            onClick={() => setActiveSection('aviso-legal')}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#9DD8CC', 
              margin: '0 10px', 
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '0.85rem'
            }}
          >
            Aviso Legal
          </button>
          <button 
            onClick={() => setActiveSection('privacidad')}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#9DD8CC', 
              margin: '0 10px', 
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '0.85rem'
            }}
          >
            Política de Privacidad
          </button>
          <button 
            onClick={() => setActiveSection('cookies')}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#9DD8CC', 
              margin: '0 10px', 
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '0.85rem'
            }}
          >
            Política de Cookies
          </button>
        </div>
        
        <p style={{ marginTop: '1rem', fontSize: '0.8rem' }}>
          © 2026 Phone Paradise | C/MAYOR 17, 08389 PALAFOLLS, BARCELONA
        </p>
        <p style={{ marginTop: '0.5rem', fontSize: '0.75rem' }}>
          🕒 Horario: Lunes a Viernes de 10:00 a 13:30 y 17:00 a 20:00 | Sábados de 10:00 a 13:00
        </p>
      </div>
    </footer>
  );
};

export default Footer;